'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _HiddenMeasure = require('../layout/utils/HiddenMeasure');

var _HiddenMeasure2 = _interopRequireDefault(_HiddenMeasure);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _Overflows = require('../utils/Overflows');

var _decorators = require('../utils/propTypes/decorators');

var _Timers = require('../utils/Timers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UITruncateString = (0, _memoWithDisplayName2.default)('UITruncateString', function (props) {
  var children = props.children,
      className = props.className,
      fixedChildren = props.fixedChildren,
      innerClassName = props.innerClassName,
      matchContentWidth = props.matchContentWidth,
      maxWidth = props.maxWidth,
      onTruncatedChange = props.onTruncatedChange,
      placement = props.placement,
      reverse = props.reverse,
      tooltip = props.tooltip,
      useFlex = props.useFlex,
      rest = _objectWithoutProperties(props, ['children', 'className', 'fixedChildren', 'innerClassName', 'matchContentWidth', 'maxWidth', 'onTruncatedChange', 'placement', 'reverse', 'tooltip', 'useFlex']);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      contentWidth = _useState2[0],
      setContentWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      isTruncated = _useState4[0],
      setIsTruncated = _useState4[1];

  var wrapperRef = (0, _react.useRef)(null);
  var measureRef = (0, _react.useRef)(null);
  var tailRef = (0, _react.useRef)(null);

  // Workaround for a truly bizarre Safari bug (#5825); still replicable as of Safari 13.0.5
  var keyRef = (0, _react.useRef)(0);
  var hasMaxWidth = maxWidth != null;
  var hasMaxWidthRef = (0, _react.useRef)(hasMaxWidth);
  if (hasMaxWidthRef.current !== hasMaxWidth) {
    keyRef.current += 1;
    hasMaxWidthRef.current = hasMaxWidth;
  }
  var key = keyRef.current;

  var updateTruncatedState = function updateTruncatedState() {
    var wrapperEl = wrapperRef.current;
    var tailEl = tailRef.current;

    if (matchContentWidth) {
      var measureEl = (0, _reactDom.findDOMNode)(measureRef.current);
      setContentWidth(measureEl.clientWidth + 1);
    }

    var newIsTruncated = reverse ? (0, _Overflows.overflowsX)(tailEl, wrapperEl) : (0, _Overflows.overflowsX)(wrapperEl);

    if (newIsTruncated !== isTruncated) {
      setIsTruncated(newIsTruncated);
      if (onTruncatedChange) onTruncatedChange((0, _SyntheticEvent2.default)(newIsTruncated));
    }
  };

  // Using a scheduler callback ensures that measurement is batched, preventing extra layout costs
  var delayTimeoutRef = (0, _react.useRef)(null);
  var delayedUpdateTruncatedState = function delayedUpdateTruncatedState() {
    (0, _Timers.cancelSchedulerCallback)(delayTimeoutRef.current);
    delayTimeoutRef.current = (0, _Timers.requestSchedulerCallback)(updateTruncatedState);
  };

  // Add mount/unmount behavior
  (0, _react.useEffect)(function () {
    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(delayedUpdateTruncatedState);
      resizeObserver.observe(wrapperRef.current);
      return function () {
        (0, _Timers.cancelSchedulerCallback)(delayTimeoutRef.current);
        resizeObserver.disconnect();
      };
    } else {
      updateTruncatedState();
      addEventListener('resize', delayedUpdateTruncatedState);
      return function () {
        removeEventListener('resize', delayedUpdateTruncatedState);
      };
    }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  // When maxWidth is set, we need to set maxWidth on both the outer container and the inner
  // wrapper. We also need to set width to "unset" (if we aren't using matchContentWidth) in
  // order to prevent the table column from collapsing to 0 due to the `width: 100%` rule.
  var computedMaxWidth = maxWidth && contentWidth ? Math.min(maxWidth, contentWidth) : maxWidth || contentWidth;
  var style = computedMaxWidth ? {
    maxWidth: computedMaxWidth,
    width: maxWidth ? 'unset' : undefined
  } : undefined;

  var tailClassName = (0, _classnames2.default)('private-truncated-string__reverse__tail', {
    'is-truncated': isTruncated
  });

  var renderedContent = reverse ? _react2.default.createElement(
    'span',
    { className: 'private-truncated-string__reverse' },
    isTruncated && _react2.default.createElement(
      'span',
      { className: 'private-truncated-string__reverse__ellipse' },
      '\u2026'
    ),
    _react2.default.createElement(
      'span',
      { className: tailClassName },
      _react2.default.createElement(
        'span',
        {
          className: 'private-truncated-string__reverse__content',
          ref: tailRef
        },
        children
      )
    )
  ) : _react2.default.createElement(
    'span',
    null,
    children
  );

  var computedTooltip = tooltip === true ? children : tooltip;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _UITooltip2.default,
      {
        disabled: isTruncated === false,
        placement: placement,
        title: computedTooltip
      },
      _react2.default.createElement(
        'span',
        _extends({}, rest, {
          className: (0, _classnames2.default)('private-truncated-string', className, {
            'private-truncated-string--is-flex': useFlex,
            'private-truncated-string--has-tooltip': Boolean(isTruncated && computedTooltip)
          }),
          'data-content': true,
          key: key,
          style: style
        }),
        _react2.default.createElement(
          'span',
          {
            className: (0, _classnames2.default)('private-truncated-string__inner', innerClassName),
            ref: wrapperRef,
            style: style
          },
          renderedContent
        ),
        fixedChildren
      )
    ),
    matchContentWidth && _react2.default.createElement(
      _HiddenMeasure2.default,
      { ref: measureRef },
      children
    )
  );
});

UITruncateString.propTypes = {
  children: _propTypes2.default.node.isRequired,
  fixedChildren: _propTypes2.default.node,
  innerClassName: _propTypes2.default.string,
  matchContentWidth: _propTypes2.default.bool.isRequired,
  maxWidth: _propTypes2.default.number,
  onTruncatedChange: (0, _decorators.hidden)(_propTypes2.default.func),
  placement: _UITooltip2.default.propTypes.placement,
  reverse: _propTypes2.default.bool.isRequired,
  tooltip: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node, _propTypes2.default.string]).isRequired,
  useFlex: _propTypes2.default.bool.isRequired
};

UITruncateString.defaultProps = {
  placement: _UITooltip2.default.defaultProps.placement,
  reverse: false,
  tooltip: true,
  matchContentWidth: false,
  useFlex: false
};

exports.default = UITruncateString;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/text/UITruncateString.js
// module id = 44
// module chunks = 177